<template>
    <v-menu
      transition="scale-transition"
      open-on-hover
      close-on-click
      close-on-content-click
      offset-y
    >
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" text class="my-vbtn pr-12">
          <v-icon>keyboard_arrow_down</v-icon>

          <Avatar :username="username" :size="40"></Avatar>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item @click="route('MyClients')" class="cursor-pointer">
          <v-list-item-title>
            <v-icon>accessible</v-icon>
            <span class="ml-2">My Patients</span>
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="route('GenerateQR')" class="cursor-pointer">
          <v-list-item-title>
            <span class="ml-2">QR Generate</span>
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="logout" class="cursor-pointer">
          <v-list-item-title>
            <v-icon>logout</v-icon>
            <span class="ml-2">Logout</span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
</template>

<script>
import Avatar from "vue-avatar";
export default {
  name: "UserMenu",
  components: { Avatar },
  computed: {
    username() {
      return this.$store.getters.username;
    },
  },
  methods: {
    route(to) {
      this.$router.push({
        name: to,
      });
    },
    logout() {
      localStorage.removeItem('apollo-token')
      this.$router.push({
        name: 'welcome',
      });
    },
  },
};
</script>
